export const loadScript = (
  id: string,
  src: string,
  onLoad?: () => void
): void => {
  if (typeof document === 'undefined') {
    return
  }
  try {
    const existing = document.getElementById(id)
    if (existing) {
      // Script tag already present; if it already finished loading, fire
      // onLoad immediately rather than waiting for an event that already fired.
      if (onLoad && (existing as HTMLScriptElement).dataset.loaded === 'true') {
        onLoad()
      }
      return
    }
    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = true
    if (onLoad) {
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true'
        onLoad()
      })
    }
    document.head.appendChild(script)
  } catch {
    // A failed script injection must never break page rendering (FR-012).
  }
}
